import { useEffect } from "react";

export default function ConfirmacionCompra() {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  useEffect(() => {
    if (typeof window !== 'undefined' && (window as any).fbq) {
      (window as any).fbq('track', 'Purchase', {
        value: 175,
        currency: 'EUR',
        content_name: 'Prerreserva YSCC — 2ª edición',
        content_type: 'product',
      });
    }
  }, []);

  const fechaPago = new Date().toLocaleDateString('es-ES', {
    day: 'numeric',
    month: 'long',
    year: 'numeric',
  });

  return (
    <div className="min-h-screen" style={{ background: "#f0f4f8" }}>
      {/* Header */}
      <header className="bg-white shadow-lg">
        <div className="max-w-5xl mx-auto px-6 py-4 flex items-center">
          <img
            alt="NSCA Spain Logo"
            className="h-14 w-auto"
            src="https://static.readdy.ai/image/e4930f1328430401d33e8e8f8ac29155/e1e681509551cb55badc2894ba94db57.png"
          />
        </div>
      </header>

      {/* Hero */}
      <div
        className="relative overflow-hidden"
        style={{ background: "linear-gradient(135deg, #185a7d 0%, #1a6a92 60%, #185a7d 100%)" }}
      >
        <div className="absolute inset-0 opacity-10">
          <div className="absolute top-0 right-0 w-96 h-96 rounded-full bg-white"></div>
          <div className="absolute bottom-0 left-0 w-64 h-64 rounded-full bg-white"></div>
        </div>
        <div className="max-w-5xl mx-auto px-4 sm:px-6 py-8 sm:py-10 relative flex flex-col items-center sm:flex-row sm:items-center sm:justify-between gap-6">
          <div className="flex-1 text-center">
            <div
              className="w-16 h-16 rounded-full flex items-center justify-center mx-auto mb-4"
              style={{ background: "rgba(255,255,255,0.2)" }}
            >
              <i className="ri-check-double-line text-3xl text-white"></i>
            </div>
            <h1 className="text-2xl sm:text-3xl font-extrabold text-white mb-2 tracking-tight">
              ¡Reserva confirmada!
            </h1>
            <p className="text-sm sm:text-base text-white/80 mb-3 max-w-xl mx-auto">
              Tu reserva en el{" "}
              <strong className="text-white">
                YSCC Youth Strength and Conditioning Coach — 2ª edición
              </strong>{" "}
              está asegurada.
            </p>
            {/* Precio especial badge */}
            <div className="inline-flex items-center gap-2 bg-amber-400/90 text-amber-900 px-4 sm:px-5 py-2 rounded-full font-bold text-xs sm:text-sm mb-4">
              <i className="ri-star-fill text-base"></i>
              ¡Enhorabuena! Has entrado al precio especial de prerreserva
            </div>
            <div className="flex justify-center">
              <div className="inline-flex items-center gap-2 bg-white/20 backdrop-blur-sm text-white px-4 sm:px-5 py-2.5 rounded-full border border-white/30 font-semibold text-xs sm:text-sm">
                <i className="ri-calendar-check-line text-base"></i>
                Inicio del certificado: 23 de mayo de 2026
              </div>
            </div>
          </div>
          <div className="flex-shrink-0 flex items-end justify-center sm:self-end">
            <img
              alt="YSCC sticker"
              className="h-80 sm:h-72 w-auto object-contain object-bottom select-none"
              src="https://static.readdy.ai/image/e4930f1328430401d33e8e8f8ac29155/af8316e908f54c0d096e3c7e9770dd71.png"
            />
          </div>
        </div>
      </div>

      {/* Main content */}
      <main className="max-w-5xl mx-auto px-4 sm:px-6 py-6 sm:py-8 space-y-6 sm:space-y-7">

        {/* Detalle del pago + Ya en tu mochila */}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-5">
          {/* Detalle del pago */}
          <section className="md:col-span-2">
            <div className="flex items-center gap-3 mb-4">
              <div
                className="w-7 h-7 rounded-full flex items-center justify-center text-white text-xs font-bold"
                style={{ background: "#185a7d" }}
              >
                1
              </div>
              <h2 className="text-lg font-bold text-gray-800">Detalle del pago</h2>
            </div>
            <div className="bg-white rounded-2xl shadow-md border border-gray-100 overflow-hidden">
              <div className="divide-y divide-gray-100">
                <div className="flex items-center justify-between px-4 sm:px-6 py-4 gap-3">
                  <div className="flex items-center gap-2.5 text-gray-500 flex-shrink-0">
                    <i className="ri-file-text-line text-base"></i>
                    <span className="text-sm">Concepto</span>
                  </div>
                  <span className="font-semibold text-gray-800 text-sm text-right">
                    Prerreserva YSCC — 2ª edición
                  </span>
                </div>
                <div className="flex items-center justify-between px-4 sm:px-6 py-4 gap-3">
                  <div className="flex items-center gap-2.5 text-gray-500 flex-shrink-0">
                    <i className="ri-calendar-line text-base"></i>
                    <span className="text-sm">Fecha de pago</span>
                  </div>
                  <span className="font-semibold text-gray-800 text-sm text-right">
                    {fechaPago}
                  </span>
                </div>
                <div className="flex items-center justify-between px-4 sm:px-6 py-4 gap-3">
                  <div className="flex items-center gap-2.5 text-gray-500 flex-shrink-0">
                    <i className="ri-bank-card-line text-base"></i>
                    <span className="text-sm">Método de pago</span>
                  </div>
                  <span className="font-semibold text-gray-800 text-sm text-right">
                    Tarjeta de crédito
                  </span>
                </div>
                <div className="flex items-center justify-between px-4 sm:px-6 py-4">
                  <div className="flex items-center gap-2.5 text-gray-500">
                    <i className="ri-checkbox-circle-line text-base"></i>
                    <span className="text-sm">Estado</span>
                  </div>
                  <span className="inline-flex items-center gap-1.5 bg-green-50 text-green-700 px-3 py-1 rounded-full text-xs font-semibold border border-green-200">
                    <i className="ri-checkbox-circle-fill"></i> Pagado
                  </span>
                </div>
              </div>
              <div className="px-4 sm:px-6 py-4 flex items-center justify-between border-t border-gray-100">
                <span className="text-base font-bold text-gray-800">Total abonado</span>
                <span className="text-3xl font-extrabold" style={{ color: "#185a7d" }}>175 €</span>
              </div>
              <div className="px-4 sm:px-6 py-3 bg-gray-50 border-t border-gray-100 text-center">
                <p className="text-xs text-gray-400 flex items-center justify-center gap-1.5">
                  <i className="ri-mail-send-line"></i>
                  Recibirás un correo con los detalles de tu compra
                </p>
              </div>
            </div>
          </section>

          {/* Ya en tu mochila */}
          <section className="flex flex-col">
            <div className="flex items-center gap-3 mb-4">
              <div
                className="w-7 h-7 rounded-full flex items-center justify-center text-white text-xs font-bold"
                style={{ background: "#185a7d" }}
              >
                <i className="ri-medal-line text-xs"></i>
              </div>
              <h2 className="text-lg font-bold text-gray-800">Ya en tu mochila</h2>
            </div>
            <div
              className="bg-white rounded-2xl shadow-md border-2 p-6 flex flex-col gap-3 items-center text-center flex-1 justify-center"
              style={{ borderColor: "#185a7d" }}
            >
              <p className="text-xs font-semibold uppercase tracking-widest" style={{ color: "#185a7d" }}>
                Acceso al YSCC 2ª edición
              </p>
              <img
                alt="Logo YSCC"
                className="w-32 h-32 object-contain mx-auto"
                src="https://static.readdy.ai/image/e4930f1328430401d33e8e8f8ac29155/c277a5be8bdcc9b11e6b0d3246e11bd5.png"
              />
              <div>
                <h3 className="font-bold text-gray-800 text-sm">
                  YSCC — Youth Strength &amp; Conditioning Coach
                </h3>
                <p className="text-xs text-gray-400 mt-1">2ª edición · NSCA Spain</p>
              </div>
            </div>
          </section>
        </div>

        {/* Pago restante */}
        <section>
          <div className="flex items-center gap-3 mb-4">
            <div
              className="w-7 h-7 rounded-full flex items-center justify-center text-white text-xs font-bold"
              style={{ background: "#185a7d" }}
            >
              2
            </div>
            <h2 className="text-lg font-bold text-gray-800">Pago restante del certificado</h2>
          </div>
          <div className="rounded-2xl overflow-hidden shadow-md border border-gray-100 bg-white">
            <div
              className="px-4 sm:px-6 py-4 flex items-start sm:items-center gap-3 border-b"
              style={{ background: "#fff8e6", borderColor: "#f5d87a" }}
            >
              <div
                className="w-9 h-9 rounded-xl flex items-center justify-center flex-shrink-0"
                style={{ background: "#fde68a" }}
              >
                <i className="ri-alarm-warning-line text-xl" style={{ color: "#b45309" }}></i>
              </div>
              <div>
                <p className="font-bold text-sm" style={{ color: "#92400e" }}>
                  Recuerda: en mayo deberás abonar el resto del certificado
                </p>
                <p className="text-xs" style={{ color: "#b45309" }}>
                  Los 175 € de prerreserva ya están incluidos en el precio total
                </p>
              </div>
            </div>
            <div className="grid grid-cols-1 md:grid-cols-2 gap-0 divide-y md:divide-y-0 md:divide-x divide-gray-100">
              {/* Opción A */}
              <div className="px-4 sm:px-6 py-6 flex flex-col gap-3">
                <div className="flex items-center gap-3">
                  <div className="w-10 h-10 rounded-xl flex items-center justify-center flex-shrink-0 bg-white shadow-sm border border-gray-100">
                    <i className="ri-coins-line text-xl" style={{ color: "#185a7d" }}></i>
                  </div>
                  <p className="text-xs font-semibold uppercase tracking-wider text-gray-500">
                    Opción A · Pago único
                  </p>
                </div>
                <div className="bg-[#185a7d]/5 border border-[#185a7d]/15 rounded-2xl px-5 py-4 flex flex-col gap-3">
                  <div className="flex items-center justify-between py-2 border-b border-[#185a7d]/10">
                    <span className="text-xs text-gray-500">Precio total</span>
                    <span className="text-base font-bold text-gray-700">675 €</span>
                  </div>
                  <div className="flex items-center justify-between py-2 border-b border-[#185a7d]/10">
                    <span className="text-xs text-gray-500">Ya abonado</span>
                    <span className="text-base font-semibold text-green-600">− 175 €</span>
                  </div>
                  <div className="flex items-center justify-between pt-1">
                    <span className="text-sm font-bold text-gray-800">Falta por abonar</span>
                    <span className="text-4xl font-black" style={{ color: "#185a7d" }}>500 €</span>
                  </div>
                  <p className="text-xs text-gray-400 text-center">en mayo · pago único</p>
                </div>
                <div className="inline-flex items-center gap-1 px-2.5 py-1 rounded-full text-xs font-semibold self-start"
                  style={{ background: "#d1fae5", color: "#065f46" }}>
                  <i className="ri-check-line"></i> Sin recargos
                </div>
              </div>
              {/* Opción B */}
              <div className="px-4 sm:px-6 py-6 flex flex-col gap-3">
                <div className="flex items-center gap-3">
                  <div className="w-10 h-10 rounded-xl flex items-center justify-center flex-shrink-0 bg-white shadow-sm border border-gray-100">
                    <i className="ri-calendar-2-line text-xl" style={{ color: "#185a7d" }}></i>
                  </div>
                  <p className="text-xs font-semibold uppercase tracking-wider text-gray-500">
                    Opción B · 3 plazos
                  </p>
                </div>
                <div className="bg-[#185a7d]/5 border border-[#185a7d]/15 rounded-2xl px-5 py-4 flex flex-col gap-3">
                  <div className="flex items-center justify-between py-2 border-b border-[#185a7d]/10">
                    <span className="text-xs text-gray-500">Precio total</span>
                    <span className="text-base font-bold text-gray-700">775 €</span>
                  </div>
                  <div className="flex items-center justify-between py-2 border-b border-[#185a7d]/10">
                    <span className="text-xs text-gray-500">Ya abonado</span>
                    <span className="text-base font-semibold text-green-600">− 175 €</span>
                  </div>
                  <div className="pt-1">
                    <p className="text-sm font-bold text-gray-800 mb-3">Falta por abonar</p>
                    <div className="flex items-center justify-between gap-2">
                      {[
                        { mes: "Mayo", importe: "200 €" },
                        { mes: "Junio", importe: "200 €" },
                        { mes: "Julio", importe: "200 €" },
                      ].map(({ mes, importe }) => (
                        <div key={mes} className="flex-1 text-center bg-white rounded-xl py-3 shadow-sm border border-[#185a7d]/10">
                          <div className="text-2xl font-black" style={{ color: "#185a7d" }}>{importe}</div>
                          <div className="text-xs text-gray-500 mt-0.5 font-medium">{mes}</div>
                        </div>
                      ))}
                    </div>
                  </div>
                </div>
                <div className="inline-flex items-center gap-1 px-2.5 py-1 rounded-full text-xs font-semibold self-start bg-amber-50 text-amber-700">
                  <i className="ri-information-line"></i> +100 € respecto al pago único
                </div>
              </div>
            </div>
            <div className="px-4 sm:px-6 py-3 border-t border-gray-100 text-center bg-gray-50">
              <p className="text-xs text-gray-400 flex items-center justify-center gap-1.5">
                <i className="ri-information-line"></i>
                El equipo del YSCC te informará sobre cómo realizar el pago restante
              </p>
            </div>
          </div>
        </section>

        {/* Próximos pasos + Contacto */}
        <div className="grid grid-cols-1 md:grid-cols-2 gap-5">
          {/* Próximos pasos */}
          <section>
            <div className="flex items-center gap-3 mb-4">
              <div
                className="w-7 h-7 rounded-full flex items-center justify-center text-white text-xs font-bold"
                style={{ background: "#185a7d" }}
              >
                3
              </div>
              <h2 className="text-lg font-bold text-gray-800">Próximos pasos</h2>
            </div>
            <div className="bg-white rounded-2xl shadow-md border border-gray-100 p-5 sm:p-6 flex flex-col gap-5 h-full">
              <div className="flex items-start gap-4">
                <div
                  className="w-10 h-10 rounded-xl flex items-center justify-center flex-shrink-0"
                  style={{ background: "#e0f2f7" }}
                >
                  <i className="ri-team-line text-xl" style={{ color: "#185a7d" }}></i>
                </div>
                <div>
                  <h3 className="font-bold text-gray-800 text-sm mb-1">
                    El equipo del YSCC te contactará
                  </h3>
                  <p className="text-xs text-gray-500 leading-relaxed">
                    La semana próxima recibirás un mensaje con toda la información: acceso a la
                    plataforma, calendario de sesiones y detalles adicionales.
                  </p>
                </div>
              </div>
              <div className="flex items-start gap-4">
                <div
                  className="w-10 h-10 rounded-xl flex items-center justify-center flex-shrink-0"
                  style={{ background: "#e0f2f7" }}
                >
                  <i className="ri-mail-check-line text-xl" style={{ color: "#185a7d" }}></i>
                </div>
                <div>
                  <h3 className="font-bold text-gray-800 text-sm mb-1">Revisa tu correo</h3>
                  <p className="text-xs text-gray-500 leading-relaxed">
                    Te hemos enviado un correo de confirmación con todos los detalles de tu
                    prerreserva.
                  </p>
                </div>
              </div>
            </div>
          </section>

          {/* Contacto y soporte */}
          <section>
            <div className="flex items-center gap-3 mb-4">
              <div
                className="w-7 h-7 rounded-full flex items-center justify-center text-white text-xs font-bold"
                style={{ background: "#185a7d" }}
              >
                4
              </div>
              <h2 className="text-lg font-bold text-gray-800">Contacto y soporte</h2>
            </div>
            <div
              className="rounded-2xl shadow-md overflow-hidden h-full"
              style={{ background: "linear-gradient(135deg, #185a7d 0%, #1a6a92 100%)" }}
            >
              <div className="p-5 sm:p-6 text-center text-white flex flex-col items-center justify-center h-full gap-4">
                <div className="w-12 h-12 rounded-full flex items-center justify-center bg-white/20">
                  <i className="ri-customer-service-2-line text-2xl"></i>
                </div>
                <div>
                  <h3 className="text-base font-bold mb-1">¿Necesitas ayuda?</h3>
                  <p className="text-white/70 text-xs mb-4">
                    Nuestro equipo está disponible para resolver cualquier duda
                  </p>
                </div>
                <a
                  href="mailto:info@nsca.es"
                  className="flex items-center gap-3 bg-white/10 hover:bg-white/20 transition-colors rounded-xl p-4 cursor-pointer w-full max-w-xs"
                >
                  <div className="w-9 h-9 flex items-center justify-center bg-white/20 rounded-lg flex-shrink-0">
                    <i className="ri-mail-line text-lg text-white"></i>
                  </div>
                  <div className="text-left">
                    <p className="text-xs text-white/60 mb-0.5">Email</p>
                    <p className="text-sm font-semibold text-white">info@nsca.es</p>
                  </div>
                </a>
              </div>
            </div>
          </section>
        </div>
      </main>

      {/* Footer */}
      <footer
        className="mt-4"
        style={{ background: "linear-gradient(135deg, #185a7d 0%, #1a6a92 100%)" }}
      >
        <div className="max-w-5xl mx-auto px-6 py-5 flex flex-col md:flex-row justify-between items-center gap-3">
          <img
            alt="NSCA Spain Logo"
            className="h-10 w-auto"
            src="https://static.readdy.ai/image/e4930f1328430401d33e8e8f8ac29155/e1e681509551cb55badc2894ba94db57.png"
          />
          <p className="text-white/60 text-xs">
            YSCC — 2ª edición · © 2026 NSCA Spain. Todos los derechos reservados.
          </p>
        </div>
      </footer>
    </div>
  );
}
